import { ReactNode, useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

import styled from 'styled-components'

import { colors } from '../../../constants/colors'
import { breakpoints } from '../../breakPoints'
import { FlexColumnStart } from '../../projectComponents'
import { verticalScroll } from '../../scroll'

const ModalBackground = styled.div<{ $mobileTabletOnly: boolean; $viewModal: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  height: 100lvh;
  display: flex;
  background-color: rgba(0, 0, 0, 0.5);
  align-items: flex-end;
  justify-content: flex-end;
  z-index: 2300;
  transition: 0.4s ease-in;
  visibility: ${({ $viewModal }) => ($viewModal ? '' : 'hidden')};
  opacity: ${({ $viewModal }) => ($viewModal ? '1' : '0')};

  @media (width >= ${breakpoints.desktopMin}) {
    display: ${({ $mobileTabletOnly }) => ($mobileTabletOnly ? 'none' : 'flex')};
  }

  & > div {
    transform: ${({ $viewModal }) => ($viewModal ? 'translateX(0)' : 'translateX(100%)')};
    transition: 0.3s cubic-bezier(0.87, 0, 0.13, 1);
  }

  @media (width < ${breakpoints.mobileMax}) {
    &:has([data-main-menu]) {
      height: 100dvh;
    }
  }
`

const ModalWrapper = styled(FlexColumnStart)`
  justify-content: flex-start;
  align-items: stretch;
  margin-top: 16px;
  width: 370px;
  min-height: 100%;
  box-sizing: border-box;
  padding: 28px 24px;
  box-shadow: 0px -9px 15.7px 0px rgba(94, 94, 94, 0.07);
  background-color: ${colors.white};
  gap: 24px;
  overflow: auto;
  ${verticalScroll}

  &:has([data-main-menu]) {
    position: relative;
    width: min(345px, 100vw);
    height: 100%;
    min-height: 0;
    margin-top: 0;
    padding: 0 36px 17px 35px;
    gap: 0;

    @media (width < ${breakpoints.mobileMax}) {
      width: 100%;
      padding: 0 16px max(25px, env(safe-area-inset-bottom));

      > [data-main-menu] {
        max-width: 274px;
        margin-inline: auto;
        padding-top: max(54px, env(safe-area-inset-top));
      }
    }

    > button {
      top: 10px;
      right: 10px;
      width: 38px;
      height: 38px;
      border-radius: 10px;
      background: ${colors.lightGray};

      img {
        content: url('/images/main-menu/close.svg');
        width: 24px;
        height: 24px;
        padding: 4.25px;
      }
    }
  }
`
const CloseWrapper = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  background: transparent;
  position: absolute;
  top: 40px;
  right: 30px;
  cursor: pointer;
  z-index: 2400;
`

type Props = {
  children?: ReactNode
  mobileTabletOnly?: boolean
  setViewModal: (viewModal: boolean) => void
  viewModal: boolean
}

const preventClick = e => {
  e.stopPropagation()
}

export const RightModal = ({
  children,
  mobileTabletOnly = false,
  setViewModal,
  viewModal,
}: Props) => {
  const [portalNode, setPortalNode] = useState<HTMLElement | null>(null)

  useEffect(() => {
    setPortalNode(document.body)
  }, [])

  if (!portalNode) {
    return null
  }

  return createPortal(
    <ModalBackground
      $mobileTabletOnly={mobileTabletOnly}
      $viewModal={viewModal}
      onClick={() => setViewModal(false)}
    >
      <ModalWrapper onClick={preventClick}>
        <CloseWrapper aria-label={'Закрыть'} type={'button'} onClick={() => setViewModal(false)}>
          <img alt={'close'} height={20} src={'/images/buttons/close.png'} width={20} />
        </CloseWrapper>
        {children}
      </ModalWrapper>
    </ModalBackground>,
    portalNode
  )
}
